module.exports = __webpack_public_path__ + "static/media/AMAPTelos.9f0e9a7d.svg";